import { Injectable, PipeTransform, Pipe } from '@angular/core';
import { __i18n } from '@localisation';

@Injectable()
export class M2MDeviceStateTranslationService {
    private states: object = {
        ActiveLive: __i18n('Active live', 'deviceState.activeLive'),
        ActiveReady: __i18n('Active ready', 'deviceState.activeReady'),
        ActiveSleep: __i18n('Active sleep', 'deviceState.activeSleep'),
        ActiveStandby: __i18n('Active standby', 'deviceState.activeStandby'),
        ActiveSuspend: __i18n('Active suspend', 'deviceState.activeSuspend'),
        ActiveTest: __i18n('Active test', 'deviceState.activeTest'),
        Inactive: __i18n('Inactive', 'deviceState.inactive'), // obsolete
        InactiveNew: __i18n('Inactive new', 'deviceState.inactiveNew'), // obsolete
        InactiveStopped: __i18n('Inactive stopped', 'deviceState.inactiveStopped'),
        InactiveTransformed: __i18n('Inactive transformed', 'deviceState.inactiveTransformed'),
        MigratedFromOtherGdspEnvironment: __i18n('Migrated from other GDSP environment',
            'deviceState.migratedFromOtherGdspEnvironment'),
        MigratedToOtherGdspEnvironment: __i18n('Migrated to other GDSP environment',
            'deviceState.migratedToOtherGdspEnvironment'),
        NotProvisioned: __i18n('Not provisioned', 'deviceState.notProvisioned'),
        SuspendRegulatory: __i18n('Suspend regulatory', 'deviceState.suspendRegulatory'),
        Terminated: __i18n('Terminated', 'deviceState.terminated') // obsolete
    };

    public getLocalizedDeviceState(state: string): string {
        return this.states[state] || state;
    }
}

@Pipe({
    name: 'translateM2MDeviceState',
    standalone: false
})
@Injectable()
export class TranslateM2MDeviceStatePipe implements PipeTransform {
    constructor(
        private m2MDeviceStateTranslationService: M2MDeviceStateTranslationService) {
            // Nothing to do here.
        }

    public transform(value: string): string {
        return this.m2MDeviceStateTranslationService.getLocalizedDeviceState(value);
    }
}

export function m2MDeviceStateTranslationsFactory() {
    return new M2MDeviceStateTranslationService();
}

export const M2MDeviceStateTranslationsProvider = {
    provide: M2MDeviceStateTranslationService,
    useFactory: m2MDeviceStateTranslationsFactory,
    deps: []
};
